import { useEffect, useRef } from 'react';
import uuid from 'uuid-random';
import { path } from 'js/utils/ramda.util';
import { useDispatch, useSelector } from 'react-redux';
import { LIVE_GAMES_REDUCER } from 'js/store/constants';
import { useUnmountEffect } from 'js/hooks/useUnmountEffect';
import { useLiveGamesSubscribe, useLiveGamesUnsubscribe } from 'js/hooks/useLiveGamesIntegration';

import * as actions from '../store/actions';

export const useLiveGames = ({ liveLaunchAliases = [], preventSubscribe = false }) => {
    const dispatch = useDispatch();
    const correlationId = useRef(uuid());
    const liveGamesSubscribe = useLiveGamesSubscribe();
    const liveGamesUnsubscribe = useLiveGamesUnsubscribe();
    const isSocketConnected = useSelector(path([LIVE_GAMES_REDUCER, 'isSocketConnected']));

    useEffect(() => {
        if (liveLaunchAliases.length && !isSocketConnected) {
            dispatch(actions.startLiveIntegration());
        }
    }, [dispatch, liveLaunchAliases, isSocketConnected]);

    useEffect(() => {
        if (liveLaunchAliases.length && isSocketConnected && !preventSubscribe) {
            liveGamesSubscribe({
                correlationId: correlationId.current,
                tableAliases: liveLaunchAliases
            });
        }
    }, [
        liveLaunchAliases, liveGamesSubscribe,
        isSocketConnected, preventSubscribe
    ]);

    useUnmountEffect(() => {
        liveGamesUnsubscribe({ correlationIds: [correlationId.current] });
    }, [liveGamesUnsubscribe]);
};
